// extracted by mini-css-extract-plugin
export var root = "Footer-module--root--3iYWX";
export var dim = "Footer-module--dim--3Z1zz";
export var ghLink = "Footer-module--ghLink--bZWNQ";
export var resumeLink = "Footer-module--resumeLink--1O6wY";